import { render, staticRenderFns } from "./AddictiveStuffClientDiseasesAdd.vue?vue&type=template&id=647295d2&scoped=true&"
import script from "./AddictiveStuffClientDiseasesAdd.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientDiseasesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647295d2",
  null
  
)

export default component.exports